export const GET_TAX_CODES_JURISDICTIONS_REQUEST = 'GET_TAX_CODES_JURISDICTIONS_REQUEST';
export const GET_TAX_CODES_JURISDICTIONS_SUCCESS = 'GET_TAX_CODES_JURISDICTIONS_SUCCESS';
export const GET_TAX_CODES_JURISDICTIONS_FAILURE = 'GET_TAX_CODES_JURISDICTIONS_FAILURE';

export const GET_TAX_CODES_REQUEST = 'GET_TAX_CODES_REQUEST';
export const GET_TAX_CODES_SUCCESS = 'GET_TAX_CODES_SUCCESS';
export const GET_TAX_CODES_FAILURE = 'GET_TAX_CODES_FAILURE';

export const SAVE_CLIENT_TAX_CODES = 'SAVE_CLIENT_TAX_CODES';
export const SAVE_CLIENT_TAX_CODES_SUCCESS = 'SAVE_CLIENT_TAX_CODES_SUCCESS';
export const SAVE_CLIENT_TAX_CODES_FAILURE = 'SAVE_CLIENT_TAX_CODES_FAILURE';

export const GET_TAX_CODES_RATES_REQUEST = 'GET_TAX_CODES_RATES_REQUEST';
export const GET_TAX_CODES_RATES_SUCCESS = 'GET_TAX_CODES_RATES_SUCCESS';
export const GET_TAX_CODES_RATES_FAILURE = 'GET_TAX_CODES_RATES_FAILURE';

export const GET_CLIENT_TRANSACTION_TYPES_REQUEST = 'GET_CLIENT_TRANSACTION_TYPES_REQUEST';
export const GET_CLIENT_TRANSACTION_TYPES_SUCCESS = 'GET_CLIENT_TRANSACTION_TYPES_SUCCESS';
export const GET_CLIENT_TRANSACTION_TYPES_FAILURE = 'GET_CLIENT_TRANSACTION_TYPES_FAILURE';
export const RESET_CLIENT_TRANSACTION_TYPES = 'RESET_CLIENT_TRANSACTION_TYPES';
export const CLEAR_CLIENT_TRANSACTION_TYPES = 'CLEAR_CLIENT_TRANSACTION_TYPES';

export const GET_CONTINUOUS_CLIENT_TRANSACTION_TYPES_REQUEST =
  'GET_CONTINUOUS_CLIENT_TRANSACTION_TYPES_REQUEST';
export const GET_CONTINUOUS_CLIENT_TRANSACTION_TYPES_SUCCESS =
  'GET_CONTINUOUS_CLIENT_TRANSACTION_TYPES_SUCCESS';
export const GET_CONTINUOUS_CLIENT_TRANSACTION_TYPES_FAILURE =
  'GET_CONTINUOUS_CLIENT_TRANSACTION_TYPES_FAILURE';

export const SAVE_NEW_TAX_CODE_WIZARD_MAP = 'SAVE_NEW_TAX_CODE_WIZARD_MAP';

export const GET_TAX_CODES_WITH_TRANSACTION_TYPES_REQUEST =
  'GET_TAX_CODES_WITH_TRANSACTION_TYPES_REQUEST';
export const GET_TAX_CODES_WITH_TRANSACTION_TYPES_SUCCESS =
  'GET_TAX_CODES_WITH_TRANSACTION_TYPES_SUCCESS';
export const GET_TAX_CODES_WITH_TRANSACTION_TYPES_FAILURE =
  'GET_TAX_CODES_WITH_TRANSACTION_TYPES_FAILURE';
export const RESET_TAX_CODES_WITH_TRANSACTION_TYPES = 'RESET_TAX_CODES_WITH_TRANSACTION_TYPES';

export const UPDATE_TAX_CODES_SEARCH_QUERY = 'UPDATE_TAX_CODES_SEARCH_QUERY';
export const CLEAR_TAX_CODES_SEARCH_QUERY = 'CLEAR_TAX_CODES_SEARCH_QUERY';
